<template>

	<section 
		:class="[{ 'outer-pad': true, 'not-child': true, 'number-total-section-wrap': true, tabbed: ( donuts && numberTotalSmallProcessed.length > 0 && tabbed ), 'show-the-smalls': showSmalls },classes]" 
		:style="styles['number-total-section-wrap']"
	>

		<div
			:class="[{ 'info-panel' : true, 'show-overlay': true, 'no-title': !title, minimal: minimal }]" 
			:style="styles['info-panel']"
		>

			<h2 v-if="title" v-html="title" class="info-panel-title" />

			<p v-if="description" v-html="description" class="info-panel-description" />

			<hr v-if="title" />

			<slot name="standard-header" />

			<div 
				:class="[{ 'number-total-wrap-wrap' : true }]" 
			>

				<div 
					v-for="(numberTotal, numberTotalIndex) in numberTotalProcessed" 
					:key="numberTotalIndex"   
					:class="[{ 'number-total-wrap' : true }]" 
				>

					<NumberTotal 
						:total='numberTotal.total' 
						:label="numberTotal.label" 
						:labelColour="numberTotal.labelColour" 
						:tip="numberTotal.tip" 
						:jump="numberTotal.jump" 
						:minimal="minimal"
						:jumpLabel="numberTotal.jumpLabel" 
						:clickable="!!numberTotal.click"
						:n="numberTotal.n?numberTotal.n:numberTotalIndex"
						v-if="!donuts"
						@clicked="clicked(numberTotal)"
					/>

					<NumberTotalDoughnut 
						:total='numberTotal.total' 
						:label="numberTotal.label" 
						:minimal="minimal"
						:animation="animation"
						:labelColour="numberTotal.labelColour" 
						:tip="numberTotal.tip" 
						:jump="numberTotal.jump" 
						:jumpLabel="numberTotal.jumpLabel" 
						:clickable="!!numberTotal.click"
						:n="numberTotal.n?numberTotal.n:numberTotalIndex"
						@clicked="clicked(numberTotal)"
						v-if="donuts"
					/>

				</div>

			</div>

			<hr v-if="donuts && numberTotalSmallProcessed.length > 0 && showSmalls" />

			<div 
				:class="[{ 'number-total-wrap-wrap' : true }]" 
				v-if="donuts && numberTotalSmallProcessed.length > 0 && showSmalls"
			>

				<div 
					v-for="(numberTotal, numberTotalIndex) in numberTotalSmallProcessed" 
					:key="'small-'+numberTotalIndex"   
					:class="[{ 'number-total-wrap' : true }]" 
				>

					<NumberTotalDoughnut 
						:total='numberTotal.total' 
						:label="numberTotal.label" 
						:labelColour="numberTotal.labelColour" 
						:tip="numberTotal.tip" 
						:jump="numberTotal.jump" 
						:jumpLabel="numberTotal.jumpLabel" 
						:n="numberTotal.n?numberTotal.n:( numberTotalIndex + numberTotalProcessed.length )"
						v-if="donuts"
						:clickable="!!numberTotal.click"
						donutSize="small"
						@clicked="clicked(numberTotal)"
					/>

				</div>

			</div>

			<slot name="smalls-footer" v-if="donuts && numberTotalSmallProcessed.length > 0 && showSmalls" />

			<hr v-if="dataList && dataList.items && Object.keys(dataList).length>0 && dataList.items.length>0" />

			<DataList 
				v-if="dataList && dataList.items && Object.keys(dataList).length>0 && dataList.items.length>0" 
				:noPad="true" 
				:items="dataList.items" 
				:emitBubble="true" 
				@clicked="clicked" 
				:ratio="dataList.ratio?dataList.ratio:''"
			/>

			<BaseButton v-if="baseButtonSettings" :settings="baseButtonSettings" @clicked="baseButtonClick" />

			<InfoPanelOverlay :settings="overlay" />

			<span class="show-tab" v-if="!hideTabButton && donuts && numberTotalSmallProcessed.length > 0 && tabbed" v-html="''" @click="showTheSmalls2 = !showTheSmalls2" />

		</div>

	</section>

</template>

<script>
import { ref, computed, watch } from 'vue';
import NumberTotal from './NumberTotal.vue'
import NumberTotalDoughnut from './NumberTotalDoughnut.vue'
import DataList from './DataList.vue'
import BaseButton from './../BaseButton.vue'
import InfoPanelOverlay from './../InfoPanelOverlay.vue'
export default {
	name: 'NumberTotalSection',
	components: { NumberTotal, DataList, BaseButton, InfoPanelOverlay, NumberTotalDoughnut },
	props: {
		title:String,
		description:String,
		baseButtonSettings:Object,
		numberTotaLtotalColour: String, 
		numberTotaLlabelColour: String,
		numberTotaLlabel2Colour: String,
		numberTotaLlabelAlign: String, 
		numberTotaLborderColour: String, 
		numberTotaLbg: String, 
		numberTotaLshadow: Boolean, 
		numberTotals: Array,
		numberTotalsSmall: Array,
		dataList: {
			type:Object,
			default: function () { return {} }
		},
		overlay: {
			type: Object,
			default: function () { return {} }
		},
		size: {
			type: String,
			default: 'full' // small, medium, split, full
		},
		multi: {
			type: Boolean,
			default: false
		},
		minimal: {
			type: Boolean,
			default: false
		},
		donuts: {
			type: Boolean,
			default: false
		},
		hideTabButton: {
			type: Boolean,
			default: false
		},
		tabbed: {
			type: Boolean,
			default: false
		},
		showTheSmalls: {
			type: Boolean,
			default: false
		},
		animation: {
			type: Boolean,
			default: true
		}
	},
	setup(props, { emit }) {
		const showTheSmalls2 = ref(props.showTheSmalls);

		watch(showTheSmalls2, (newValue) => {
			emit('show-smalls', newValue);
		});
		
		const showSmalls = computed(() => {
			return props.tabbed ? showTheSmalls2.value : true;
		});

		const processNumberTotals = (totals) => {
			if (!totals) return [];
			return totals.map(numberTotal => {
				const numberTotalProcessed = { ...numberTotal };
				Object.keys(props).forEach(propKey => {
					if (propKey.startsWith('numberTotaL')) {
						const p = propKey.substring(11);
						const pCamel = p.charAt(0).toLowerCase() + p.slice(1);
						if (typeof numberTotalProcessed[pCamel] === 'undefined' && typeof props[propKey] !== 'undefined' && props[propKey] !== '') {
							numberTotalProcessed[pCamel] = props[propKey];
						}
					}
				});
				return numberTotalProcessed;
			});
		};

		const numberTotalProcessed = computed(() => processNumberTotals(props.numberTotals));
		const numberTotalSmallProcessed = computed(() => processNumberTotals(props.numberTotalsSmall));

		const classes = computed(() => {
			const c = {};
			c[props.size] = true;
			return c;
		});

		const styles = computed(() => {
			const styles = {};
			const styleOps = {
				'number-total-section-wrap': {
					bg: 'background-color',
					borderColour: 'border-color'
				}
			};

			Object.keys(styleOps).forEach(selector => {
				if (typeof styles[selector] === 'undefined') {
					styles[selector] = {};
				}
				Object.keys(styleOps[selector]).forEach(item => {
					if (typeof props[item] !== 'undefined') {
						styles[selector][styleOps[selector][item]] = props[item];
					}
				});
			});

			if (!props.dataList || !props.dataList.items || Object.keys(props.dataList).length === 0 || props.dataList.items.length === 0) {
				styles['info-panel'] = "paddingBottom:0; ";
			}
			return styles;
		});

		const baseButtonClick = () => {
			emit('base-button-click', props.baseButtonSettings.click);
		};

		const clicked = (itemInfo) => {
			emit('clicked', itemInfo);
		};
		
		return {
			showTheSmalls2,
			showSmalls,
			numberTotalProcessed,
			numberTotalSmallProcessed,
			classes,
			styles,
			baseButtonClick,
			clicked,
		};
	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
@import './../../assets/css/less/_helper.less';
	.frequency-setters {

		text-align: center;
		margin-bottom: 0px;
    	padding-top: 10px;
		position: relative;
		z-index: 2;

		> span {

			display: inline-block;
			background-color: @darkContrast;
			padding: 3px 8px;
			.rounded(5px);
			font-size: 12px;
			color: #fff;
			cursor: pointer;
			margin-left: 10px;
			.trans;

			&:hover, &.selected {

				background-color: @formDefaultColour;

			}

		}

	}
	.number-total-section-wrap {

		vertical-align: top;
		text-align: center;
		position: relative;
		padding-bottom: 30px;

		.info-panel {

			&.no-title {

				padding-top: 3px;
				
			}

			&.minimal {

				box-shadow: none;
				border: none;

			}

		}

		.number-total-wrap {

			display: inline-block;

		}

		.info-panel-title {
				
			text-align: left;

		}

		.number-total {

			display: inline-block;
			vertical-align: top;
			padding-top: 8px;

		}

		hr {

			margin: 8px 0 2px;

		}

		.show-tab {

			position: absolute;
			bottom: -20px;
			background-color: @darkContrast;
		    border-radius: 0 0 5px 5px;
		    z-index: 2;
		    width: 130px;
		    height: 20px;
		    left: 14px;
		    cursor: pointer;

		    &:after {

		    	content: "Show more stats";
		    	font-size: 14px;
		    	display: block;
		    	color: #fff;
		    	position: absolute;
		    	width: 100%;
		    	text-align: center;
		    	line-height: 1em;
		    	top: 3px;

		    }

		}

		&.show-the-smalls {

			.show-tab {

				&:after {

					content: "Hide more stats";

				}

			}

		}

	}

	@media screen and (min-width: 1200px) {

		.frequency-setters {

			text-align: right;

		}

		.number-total-wrap-wrap {

			display: flex;
			justify-content: space-evenly;

			.number-total-wrap {



			}

		}

	}

</style>